
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gas-tracker",
      function () {
        return require("private-next-pages/gas-tracker.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gas-tracker"])
      });
    }
  